import * as actionTypes from '../constants/actionTypes';

const initialState = {
  salesforceUser: undefined,
  profileName: undefined,
  profileId: undefined,
  channel: undefined,
  userMember: undefined
};
const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_USER_PROFILE:
      return {
        ...state,
        profileName: action.name,
        profileId: action.id
      };
    case actionTypes.SET_SALESFORCE_USER:
      return {
        ...state,
        salesforceUser: action.salesforceUser
      };
    case actionTypes.SET_USER_CHANNEL:
      return {
        ...state,
        channel: action.channel
      };
    case actionTypes.SET_USER_MEMBER:
      return {
        ...state,
        userMember: action.member
      };
    default:
      return state;
  }
};

export default userReducer;
